import { MUITab } from "@abb/arcadia-ui-react"
import { useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { UserContext } from "../../../context/UserContext"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToApplicationFeature,
} from "../../../models/Authorization"
import { TrainingGet } from "../../../models/Training"
import { useHashTab } from "../../../../hooks/useHashTab"
import { TrainingCourses } from "./courses_tab/TrainingCourses"
import { TrainingDetails } from "./details_tab/TrainingDetails"
import { TrainingPermissions } from "./permissions_tab/TrainingPermissions"
import { TrainingUsers } from "./users_tab/TrainingUsers"

const returnURL = "/trainings"

export function TrainingContainer() {
  const { trainingId } = useParams()
  const navigate = useNavigate()
  const { user } = useContext(UserContext)
  const { activeTab, handleTabChange } = useHashTab("details")

  const [training, setTraining] = useState<TrainingGet>()

  useEffect(() => {
    if (trainingId) {
      digitalManagerApi
        .get<TrainingGet>(`/trainings/${trainingId}`)
        .then((res) => {
          setTraining(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [navigate, trainingId])

  if (!trainingId) {
    return <Navigate to={returnURL} />
  }

  if (!training) {
    return <DiMaProgress />
  }

  const canReadCourses =
    !!user &&
    hasUserAccessToApplicationFeature(
      user.authorizations.applications,
      training.application.id,
      DimaFeatureShortNameEnum.TM,
      AccessLevel.Read
    )

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: training.name,
    label: "Training ID",
    subtitle: training.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[
          { id: "details", label: "Details" },
          { id: "permissions", label: "Permissions" },
          ...(canReadCourses ? [{ id: "courses", label: "Courses" }] : []),
          { id: "users", label: "Users" },
        ]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === "details" && (
        <TrainingDetails training={training} setTraining={setTraining} />
      )}
      {activeTab === "permissions" && <TrainingPermissions training={training} />}
      {canReadCourses && activeTab === "courses" && (
        <TrainingCourses training={training} />
      )}
      {activeTab === "users" && <TrainingUsers />}
    </div>
  )
}
